var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"nonzero","strokeWidth":"2.5","stroke":"currentColor","d":"M5.63 15.601C3.27 14.93 1.25 12.088 1.25 9.2V6.8c0-3.784 1.587-5.55 4.419-5.55h8.662c2.951 0 4.419 1.578 4.419 5.55 0 3.906-1.51 5.55-4.419 5.55h-4.33c-2.054 0-3.787 1.37-4.371 3.251z"}));
}

Chat.defaultProps = {"width":"20","height":"17","viewBox":"0 0 20 17"};

module.exports = Chat;

Chat.default = Chat;
